import { Properties } from "@/services/posts/types";
import { CSS } from "@/services/styles/types";

export interface RssPostProperties extends Properties {
    showTime: number;
    reloadTime: number;
    rankStart: number;
    rankEnd: number;
    sorting: string;
    url: string;
}

export interface RssItemProperties extends Properties {
    showTime: number;
    channelName: string;
    channelDescription: string;
    itemTitle: string;
    itemDescription: string;
}

export interface Rss {
    channelName: string;
    channelDescription: string;
    items: Array<RssFeed>;
}

export interface RssFeed {
    id: number;
    title: string;
    description: string;
}

export interface RssCSS extends CSS {
    channeltitle: string;
    channeldescription: string;
    itemtitle: string;
    itemdescription: string;
    wrapper: string;
}

export interface RssContentDto {
    rankStart: number;
    rankEnd: number;
    sorting: string;
    url: string;
}

export enum RssSortTypes{
    default = "default",
    publicationDate = "publicationDate"
}
